import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, EntityStringId } from 'app/types/entity';
import { Section, ISection } from 'app/constants/schemas/Section';
import { VocabSectionWord, IVocabSectionWord } from 'app/constants/schemas/VocabSectionWord';

export type IVocabSection = ISection & {
  attributes: {
    id: EntityStringId;
    vocabType: string;
  };
  associations: {
    vocabSectionWords: IVocabSectionWord[];
  };
};

export type VocabSection = Entity<IVocabSection>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabSection: IEntityType<IVocabSection> = vmClient.defineClass({
  typeName: 'VocabSection',
  version: 8,
  lockable: true,
  persisted: true,
  extends: Section,
  attributes: {
    vocabType: {
      type: 'string',
      notNull: true,
    },
  },
  associations: {
    vocabSectionWords: [VocabSectionWord],
  },
});
